import { defineStore } from 'pinia'
import { ref } from 'vue'
import profilService, { type Souscription } from '@/services/profilService'

const CACHE_TTL = 5 * 60 * 1000 // 5 minutes

export const useSubscriptionStore = defineStore('subscription', () => {
  const souscription = ref<Souscription | null>(null)
  const loading = ref(false)
  let fetchedAt = 0
  let pendingPromise: Promise<Souscription | null> | null = null

  function isFresh(): boolean {
    return fetchedAt > 0 && Date.now() - fetchedAt < CACHE_TTL
  }

  async function fetchSouscription(force = false): Promise<Souscription | null> {
    if (!force && isFresh() && souscription.value) {
      return souscription.value
    }
    if (pendingPromise) return pendingPromise

    pendingPromise = (async () => {
      loading.value = true
      try {
        const res = await profilService.getSouscription()
        if (res.data) {
          souscription.value = res.data
          fetchedAt = Date.now()
        }
        return souscription.value
      } finally {
        loading.value = false
        pendingPromise = null
      }
    })()

    return pendingPromise
  }

  function $reset() {
    souscription.value = null
    fetchedAt = 0
    pendingPromise = null
    loading.value = false
  }

  return {
    souscription,
    loading,
    fetchSouscription,
    $reset,
  }
})
